<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="Dedication-ded"><span class="ePub-I">For the Old Soldier:<br/>We are “Charlie Mike.”<br/>You can rotate home and rest easy.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?950837f4